import { ReplicaType } from "types";
import Version1 from "./v1";
import Version2 from "./v2";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "daily-prophet-hp6-death-eater-terror-continues",
  name: `The Daily Prophet\n'Death Eater Terror Continues'`,
  nameFormatted: {
    primary: "The Daily Prophet",
    secondary: "'Death Eater Terror Continues'",
  },
  origin: "Harry Potter and the Half-Blood Prince",

  category: replicaCategories.harryPotter,

  versions: [Version2, Version1],
};

export default data;
